import { EmptyState } from 'ui/emptyState';
import { DateRangeEmptyState } from 'ui/illustrations';
import {
  IntelligentInsightsBackground,
  Wrapper,
  DescriptionWrapper,
} from 'modules/intelligentInsights/IntelligentInsights.styles';

export const IntelligentInsightsNoDataForTimeframe = ({ testId }: { testId: string }) => (
  <IntelligentInsightsBackground data-test={testId}>
    <Wrapper>
      <EmptyState
        Illustration={DateRangeEmptyState}
        title={`There is no data for that date range`}
        subtitle={
          <DescriptionWrapper>
            <span>Adjust the timeframe and try again.</span>
          </DescriptionWrapper>
        }
      />
    </Wrapper>
  </IntelligentInsightsBackground>
);
